// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // When the route carries an in-page anchor (e.g. /capabilities#ap), scroll to
    // that element once the new page has rendered.
    if (hash) {
      const id = hash.replace(/^#/, "");
      window.setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
      return;
    }
    // use requestAnimationFrame to avoid race condition on mobile
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }, [pathname, hash]);

  return null;
}
